export enum FilterType {
  POINTS_ADDED = 'points-added',
  POINTS_REDEEMED = 'points-redeemed',
  POINTS_EXPIRED = 'points-expired',
  POINTS_DATE_RANGE = 'points-date-range',
  REWARDS_SORT_BY = 'sort-by',
  REWARDS_FEATURED = 'featured',
  REWARDS_CUSTOMER_SERVICE = 'customer-service',
  REWARDS_PRODUCTS = 'products',
  ALL_COUPONS = 'all-coupons',
  COUPONS_ACTIVE = 'active',
  COUPONS_REDEEMED = 'redeemed',
  COUPONS_CANCELED = 'canceled',
  COUPONS_EXPIRED = 'expired',
  EXPIRED = 'expired',
  DATE_RANGE = 'date-range',
  BUSINESS_VIP = 'business-vip',
  BUSINESS_SORT_BY = 'business-sort-by',
  BUSINESS_SERIES_F = 'business-series-f',
  BUSINESS_SERIES_S = 'business-series-s',
  BUSINESS_SERIES_G = 'business-series-g',
  GLOBAL = 'global',
  REGIONAL = 'regional',
  CALL_CENTER_AGENT = 'call-center-agent',
  VIEW_ONLY = 'view-only',
  MEXICO = 'mexico',
  BRAZIL = 'brazil',
  COLOMBIA = 'colombia',
  NOLA = 'nola',
  SOUTH = 'south',
  PACKAGE_CODES = 'package-codes',
  ACCOUNT_DATA = 'account-data',
  PORT_REPORT = 'port-report',
  PORT_BATCH_PROCESSING = 'port-batch-processing',
}
